<div
    class="agpr-filterGroup"
    [ngClass]="'agpr-filterGroup--' + selectedFilter.value.key"
    [agprLoading]="selectedFilter.value?.loading"
>
    <div class="agpr-filterGroup-dropdown">
        <agpr-dropdown
            [id]="id + '-dropdown'"
            [options]="filterOptions"
            [(ngModel)]="selectedFilter"
            ariaLabel="filterGroup"
        ></agpr-dropdown>
    </div>
    
    <div
        class="agpr-filterGroup-child"
        [ngSwitch]="selectedFilter?.value?.key"
    >
        <agpr-filter-text
            *ngSwitchCase="types.text"
            [id]="id"
            [filter]="selectedFilter.value"
            [style]="style"
        ></agpr-filter-text>
        <agpr-filter-autocomplete
            *ngSwitchCase="types.autocomplete"
            [id]="id"
            [filter]="selectedFilter.value"
            [style]="style"
        ></agpr-filter-autocomplete>
        <agpr-filter-checkboxes
            *ngSwitchCase="types.checkboxes"
            [id]="id"
            [filter]="selectedFilter.value"
            [style]="style"
        ></agpr-filter-checkboxes>
        <agpr-filter-range
            *ngSwitchCase="types.range"
            [id]="id"
            [filter]="selectedFilter.value"
            [style]="style"
        ></agpr-filter-range>
        <agpr-filter-duplicates
            *ngSwitchCase="types.duplicates"
            [id]="id"
            [filter]="selectedFilter.value"
            [style]="style"
        ></agpr-filter-duplicates>
        <agpr-filter-radio
            *ngSwitchCase="types.radio"
            [id]="id"
            [filter]="selectedFilter.value"
            [style]="style"
        ></agpr-filter-radio>
        <agpr-filter-date-query
            *ngSwitchCase="types.dateQuery"
            [id]="id"
            [filter]="selectedFilter.value"
            [style]="style"
        ></agpr-filter-date-query>
        <agpr-filter-group
            *ngSwitchCase="types.group"
            [id]="id"
            [filter]="selectedFilter.value"
            [style]="style"
        ></agpr-filter-group>
        <agpr-custom-filter-wrapper
            *ngSwitchCase="types.custom"
            [filter]="selectedFilter.value"
            [style]="style"
        ></agpr-custom-filter-wrapper>
    </div>
</div>

